import { render, staticRenderFns } from "./PhysicalChemicalFlexTableTitle.vue?vue&type=template&id=e2e22946&scoped=true&"
import script from "./PhysicalChemicalFlexTableTitle.vue?vue&type=script&lang=js&"
export * from "./PhysicalChemicalFlexTableTitle.vue?vue&type=script&lang=js&"
import style0 from "./PhysicalChemicalFlexTableTitle.vue?vue&type=style&index=0&id=e2e22946&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e22946",
  null
  
)

export default component.exports